import Vue from "vue";

export default {
  recuperarInstrumentoMusical() {
    return Vue.axios.get("instrumentoMusical");
  }
};